import { slideToggle } from '~/js/helpers';

const body = document.body;
const toggleButton = document.querySelectorAll('.offcanvas-toggler');
const offCanvasAll = document.querySelectorAll('.offcanvas');

toggleButton.forEach((button) => {
	const offCanvas = document.querySelector('[data-toggler="' + button.dataset.toggle + '"]');

	offCanvas.classList.remove('hidden');

	button.addEventListener('click', () => {
		toggleOffCanvas(offCanvas, toggleButton);
		body.classList.toggle('offcanvas-open');
		if (offCanvas.dataset.overlay) {
			body.classList.toggle('offcanvas-overlay');
		}
		toggleOffCanvasTabbing();
	});
});

offCanvasAll.forEach((offCanvas) => {
	const subMenuParent = offCanvas.querySelectorAll('.menu-item-has-children');
	const dropdownIcons = offCanvas.querySelectorAll('[data-menu-dropdown-icon]');

	dropdownIcons.forEach((icon) => icon.setAttribute('tabindex', '-1'));

	subMenuParent.forEach((parent) => {
		if (!parent.querySelector('[data-menu-dropdown-icon]')) {
			return;
		}
		parent.querySelector('[data-menu-dropdown-icon]').addEventListener('click', (e) => {
			e.preventDefault();
			toggleMobileSubmenu(parent);
		});
		parent.querySelector('[data-menu-dropdown-icon]').addEventListener('keyup', (e) => {
			if ('Enter' === e.key) {
				e.preventDefault();
				toggleMobileSubmenu(parent);
			}
		});
	});

	// Close submenu's on Esc
	document.addEventListener('keyup', (e) => {
		if ('Escape' === e.key && body.classList.contains('offcanvas-open') && offCanvas.hasAttribute('data-open')) {
			toggleOffCanvas(offCanvas, toggleButton);
			body.classList.remove('offcanvas-open');
			toggleOffCanvasTabbing();
		}
	});

	// Close submenu when focus out of last VISIBLE menu item
	let currFocus = document;
	document.addEventListener('keyup', (e) => {
		if ('Tab' === e.key && body.classList.contains('offcanvas-open')) {
			const canvasItems = offCanvas.querySelectorAll('a, button, [tabindex]');
			const visibleItems = [];
			canvasItems.forEach((item) => {
				if (item.checkVisibility()) {
					visibleItems.push(item);
				}
			});

			if (visibleItems.length && currFocus === visibleItems[visibleItems.length - 1]) {
				toggleOffCanvas(offCanvas, toggleButton);
				body.classList.remove('offcanvas-open');
				toggleOffCanvasTabbing();
			}
			currFocus = e.target;
		}
	});
});

toggleOffCanvasTabbing();

// FacetWP tabindex can only be changed with an action
document.addEventListener('facetwp-loaded', () => {
	if ('undefined' !== typeof FWP.hooks) {
		FWP.hooks.addAction(
			'facetwp/loaded',
			function () {
				toggleOffCanvasTabbing();
			},
			1000
		);
	}
});

function toggleOffCanvasTabbing() {
	const links = document.querySelectorAll(
		'.offcanvas button, .offcanvas a, .offcanvas [data-menu-dropdown-icon], .offcanvas [tabindex]'
	);
	links.forEach((link) => {
		if (!document.body.classList.contains('offcanvas-open')) {
			link.setAttribute('tabindex', '-1');
		} else {
			link.setAttribute('tabindex', '0');
		}
	});
}

function toggleMobileSubmenu(parent) {
	const subMenu = parent.querySelector('.sub-menu');
	slideToggle(subMenu);
	parent.querySelector('[data-menu-dropdown-icon]').classList.toggle('rotate-180');
}

function toggleOffCanvas(offCanvas, toggleButton) {
	const toggleClasses = ['translate-x-full', 'translate-x-0', 'pointer-events-none', 'pointer-events-auto'];
	toggleClasses.map((list) => offCanvas.classList.toggle(list));
	toggleButton.forEach((button) => {
		button.querySelectorAll('.open-button').forEach((el) => el.classList.toggle('hidden!'));
		button.querySelectorAll('.close-button').forEach((el) => el.classList.toggle('hidden!'));
	});
	offCanvas.toggleAttribute('data-open');
	document.body.classList.toggle('overflow-hidden');
}
